import { Facturation } from "@/type/core/offices/offices.types";
import configuration from "@/utils/Config";
import { restGetHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { OfficeIdsRequestDto } from "@state/balance/request/office.ids.request.dto";

const baseUrl = configuration.backendBaseUrl;
const balanceUrl = baseUrl + "/ws/fo/balance";
const balanceForOfficeUrl = baseUrl + "/ws/fo/balance/offices";

export const requestGetBalanceForOffice = createEffect({
  handler: restGetHandler<Facturation, OfficeIdsRequestDto>(
    balanceForOfficeUrl,
  ),
});

export const requestGetBalanceForEveryOffices = createEffect({
  handler: restGetHandler<Facturation>(balanceUrl),
});
